import React from 'react';
import s from './Slider.module.css';
import { Tooltip } from 'react-tooltip';

interface SliderProps {
    value: number;
    onChange: (value: number) => void;
    min?: number;
    max?: number;
    step?: number;
    showValue?: boolean;
    className?: string;
    label?: 'none' | 'number' | 'word';
}

const Slider: React.FC<SliderProps> = ({
    value,
    onChange,
    min = -100,
    max = 100,
    step = 1,
    showValue = false,
    className,
    label,
}) => {
    const tooltipId = 'slider-tooltip';

    const percentage = ((value - min) / (max - min)) * 100;

    return (
        <div className={`${s.slider_wrapper} ${className}`}>
            <div className={s.slider_container}>
                <input
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    data-tooltip-id={tooltipId}
                    data-tooltip-content={String(value)}
                    onChange={(e) => onChange(Number(e.target.value))}
                    className={s.range_input}
                    style={{ '--fill-percentage': `${percentage}%` } as React.CSSProperties}
                />
                {label === 'number' && (
                    <div className={s.percentage_labels}>
                        <span className={s.percentage_label}>0%</span>
                        <span className={s.percentage_label}>50%</span>
                        <span className={s.percentage_label}>100%</span>
                    </div>
                )}
                {label === 'word' && (
                    <div className={s.percentage_labels}>
                        <span className={s.percentage_label}>Low</span>
                        <span className={s.percentage_label}>Medium</span>
                        <span className={s.percentage_label}>High</span>
                    </div>
                )}
            </div>
            {showValue && <Tooltip id={tooltipId} place="right" className={s.tooltip} />}
        </div>
    );
};

export default Slider;
